import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, Table, Spin } from 'antd';
import { useCollection } from 'react-firebase-hooks/firestore';
import moment from 'moment';
import DownloadTable from 'components/download-table';

import { dateTimeFormat } from 'utils/dates';

import Client from 'containers/app/client';

import './style.css';

const columns = [
  {
    title: 'Employer',
    dataIndex: ['employer', 'firstName'],
    render: (value, record) => (
      <span>
        <Avatar
          src={record.employer.photoURL}
          style={{ marginRight: 'var(--margin-01)' }}
        />
        {value} {record.employer.lastName}
      </span>
    ),
  },
  {
    title: 'Worker',
    dataIndex: ['worker', 'firstName'],
    render: (value, record) => (
      <>
        {record && record.worker && (
          <span>
            <Avatar
              src={record.worker.photoURL}
              style={{ marginRight: 'var(--margin-01)' }}
            />
            {value} {record.worker.lastName}
          </span>
        )}
      </>
    ),
  },
  {
    title: 'Rate',
    dataIndex: 'rate',
    render: (value) => <span>£{value}</span>,
  },
  {
    title: 'Date created',
    dataIndex: 'timestampCreated',
  },
  {
    title: 'Date start',
    dataIndex: 'dateStart',
    render: (value) => <span>{moment(value).format(dateTimeFormat)}</span>,
  },
  {
    title: 'Date end',
    dataIndex: 'dateEnd',
    render: (value) => <span>{moment(value).format(dateTimeFormat)}</span>,
  },
  {
    title: 'Notes',
    dataIndex: 'notes',
  },
];

const BookingsWidget = ({ users }) => {
  const ref = Client.db.collection('bookings');
  const [collection, loading, error] = useCollection(ref);

  if (loading) return <Spin />;
  if (error) throw new Error(error);

  const data = collection.docs.map((doc) => {
    const docData = doc.data();
    const worker = users.find((user) => user.id === docData.worker);
    const employer = users.find((user) => user.id === docData.userId);

    return {
      key: doc.id,
      id: doc.id,
      ...docData,
      worker: worker ? worker.info : null,
      employer: employer ? employer.info : null,
      timestampCreated: moment(docData.timestampCreated.toDate()).format(
        dateTimeFormat
      ),
    };
  });

  return (
    <section className="admin-panel-section">
      <header className="admin-panel-header">
        <h2>Bookings</h2>
        <DownloadTable data={data} columns={columns} name="bookings" />
      </header>
      <Table dataSource={data} columns={columns} />
    </section>
  );
};

BookingsWidget.propTypes = {
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    })
  ).isRequired,
};

export default BookingsWidget;
